import { DashboardContent } from "@/components/dashboard/DashboardContent";
import { DashboardLayoutProvider } from "@/contexts/DashboardLayoutContext";

export default function Index() {
  return (
    <div className="w-full" dir="rtl">
      <DashboardLayoutProvider>
        <DashboardContent />
      </DashboardLayoutProvider>
    </div>
  );
}
